import React from "react";
import { FilterIcon } from "@heroicons/react/outline";
import Button from "components/Button";
import AnalyticsDatePicker from "../../AnalyticsDatePicker";
import { ActiveFilterPills } from "../../ActiveFilterPills";
import TableActions from "./TableActions";
import { trackAnalyticsActionClicked } from "utils/Tracking";

import { useModalNavigation } from "hooks/analytics";
import { ITableHeader } from "components/Table";

interface FilterControlsProps {
  tableHeaders: ITableHeader[];
  downloadButtonOnClick?: () => void | Promise<void>;
  downloadButtonText?: string;
  downloadButtonDisabled?: boolean;
  downloadButtonLoading?: boolean;
  downloadButtonLoadingText?: string;
  isMobile: boolean;
  isTablet: boolean;
}

const FilterControls: React.FC<FilterControlsProps> = ({
  tableHeaders,
  downloadButtonOnClick,
  downloadButtonText,
  downloadButtonDisabled,
  downloadButtonLoading,
  downloadButtonLoadingText,
  isMobile,
  isTablet,
}) => {
  const { navigateToModal } = useModalNavigation();

  const handleFiltersClick = () => {
    navigateToModal("/analytics/domain-analytics/filter");

    trackAnalyticsActionClicked({
      section: "global_all",
      action: "open_filters",
      target: "overview_tables",
    });
  };

  return (
  <div className="flex flex-col gap-2">
    <div className="flex flex-col lg:flex-row lg:items-center gap-2">
      {/* Primary Controls */}
      <div className="flex items-center gap-2 flex-shrink-0">
        <Button
          icon={{ Icon: FilterIcon }}
          text="FILTERS"
          className="button button-primary h-10 px-4 flex items-center gap-2 rounded text-white shrink-0"
          onClick={handleFiltersClick}
        />
        <AnalyticsDatePicker className="flex-shrink-0" inputClassName="h-10" />
      </div>

      {/* Secondary Controls */}
      <div className="hidden lg:block flex-grow" />
      <div className="flex items-center gap-2 w-full lg:w-auto justify-end">
        <TableActions
          onCustomize={() =>
            navigateToModal("/analytics/domain-analytics/customize-columns", {
              tableHeaders,
              tableType: "domain",
            })
          }
          onDownload={downloadButtonOnClick}
          downloadText={downloadButtonText}
          downloadDisabled={downloadButtonDisabled}
          downloadLoading={downloadButtonLoading}
          downloadLoadingText={downloadButtonLoadingText}
          isMobile={isMobile}
          isTablet={isTablet}
        />
      </div>
    </div>

    {/* Filter Pills */}
    <ActiveFilterPills />
  </div>
  );
};

export default FilterControls;
